import {showErrorNotification} from "../../global/notifications";

const validateField = (fieldInfo) => {
  const {name, element} = fieldInfo;
  if(element.value !== undefined && (element.value() === null || element.value() === '')) {
    element.wrapper.addClass('fieldValidationError');
    return false;
  }
  if(element.getFiles !== undefined && !element.getFiles().length) {
    element.wrapper.addClass('fieldValidationError');
    showErrorNotification(`${name} need to be selected.`);
    return false;
  }
  return true;
};

export default function(required) {
  let isInvalid = false;
  required.forEach((fieldInfo) => {
    if(!validateField(fieldInfo) && !isInvalid) {
      isInvalid = true;
    }
  });
  return !isInvalid;
}